import type { IconProps } from './types';
import './icons.css';

export default function SendMessage({
  width,
  height,
  className = '',
}: IconProps): React.JSX.Element {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width || 14}
      height={height || 10}
      viewBox="0 0 14 10"
      className={`icon icon-arrow-down ${className || ''}`}
    >
      <path
        d="M13 0v3a3 3 0 0 1-3 3H2m0 0 3-3M2 6l3 3"
        stroke="currentColor"
        strokeWidth="1.5"
        fill="transparent"
      />
    </svg>
  );
}
